<template>
  <el-submenu :popper-append-to-body="false" :index="routerInfo.name">
    <template slot="title">{{ routerInfo.meta.title }}</template>
    <slot />
  </el-submenu>
</template>

<script>
export default {
  name: "AsyncSubmenu",
  props: {
    routerInfo: {
      type: Object,
      default: () => null,
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/components/asyncSubmenu.vue